import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import usePageTracking from '../hooks/usePageTracking';
import PolicyHolderReviewClaimContainer from '../containers/policyHolderReviewClaim/policyHolderReviewClaimContainer';
import AuthenticatedUserRouter from './authenticatedUserRouter';

const ContentRouter = props => {
    usePageTracking();

    return (
        <Switch>
            <Route
                exact
                path="/action/reviewclaim/:claimApplicationId/:randomId"
                component={PolicyHolderReviewClaimContainer}
            />
            <AuthenticatedUserRouter />
        </Switch>
    );
};

export default ContentRouter;
